import type { TInterp } from "../acts/environment/i18nTypes";
import type { ScopeItemsTile } from "../data/scopeItems";

type CountedTile = Extract<ScopeItemsTile, { kind: "counted" }>;

/**
 * Os textos do tile "Scope items ativos"; a base e o motivo de não haver número o
 * detalhe repete. Ficam num lugar só para o Ato 1 e o detalhe não descreverem o
 * mesmo número com palavras diferentes.
 */

/**
 * "em 9 LoBs · 3 com observação", só com as partes que o dado sustenta. O "de
 * 316 no escopo" saiu em 21/10/2026, para limpar o tile.
 */
export function scopeItemsHint(tile: CountedTile, t: TInterp): string | undefined {
  const parts: string[] = [];
  // Zero fica de fora: no pt-BR o plural do i18next põe o 0 no singular ("em 0 LoB"),
  // e "em 0 LoBs" ao lado de um número de ativos não diz nada a quem lê.
  if (tile.lobCount) parts.push(t("across {{count}} LoBs", { count: tile.lobCount }));
  // Aqui o zero entra, porque foi contado: "sem observação" é resposta, e a parte
  // só some quando o número não vem.
  if (tile.withNote === 0) parts.push(t("no notes"));
  else if (tile.withNote != null) {
    parts.push(t("{{count}} with notes", { count: tile.withNote }));
  }
  return parts.length > 0 ? parts.join(" · ") : undefined;
}

/** A base que o número contou: o escopo aprovado ou a curadoria salva. */
export function scopeBasisLabel(
  tile: Pick<CountedTile, "basis" | "approvalVersion">,
  t: TInterp,
): string {
  if (tile.basis === "saved_curation") return t("Saved curation · scope not approved");
  return tile.approvalVersion != null
    ? t("Approved scope v{{version}}", { version: tile.approvalVersion })
    : t("Approved scope");
}

/** Por que não há número, em português de quem está na reunião. */
export function scopeItemsUnavailableReason(
  tile: Exclude<ScopeItemsTile, CountedTile>,
  t: TInterp,
): string {
  if (tile.kind === "empty") return t("The Functional run has no scope item with a verdict");
  if (tile.kind === "failed") return t("The scope items could not be read right now");
  return t("It appears after the next Functional analysis.");
}
